import React, { useEffect } from 'react';
import { LogoLoader } from '../../components/UI/Loader/LogoLoader';
import { EditBookingFound } from './EditBookingFound';
import { EDIT_BOOKING_STEPS } from '../../constants';
import { SearchComponent } from './SearchComponent';

export const EditBookingComponent = props => {
    useEffect(() => {
        props.getBookingInfo({ bookingCode: props.bookingCode, restaurantName: props.restaurantName });
    }, []);

    let mainComponent = null;

    // The search component handles the display of errors
    if (props.editBookingStep === EDIT_BOOKING_STEPS.SEARCH_BOOKING) {
        mainComponent = <SearchComponent 
            translations={props.translations} 
            isRequestingStoresList={props.isRequestingStoresList}
            hasErrorStoresListRequest={props.hasErrorStoresListRequest}
            storesList={props.storesList}
            setBookingInfo={props.setBookingInfo}
            onSearchClicked={(bookingCode, restaurantId) => props.getBookingInfo({ bookingCode, restaurantId })}
            hasErrorStoresListRequest={props.hasErrorStoresListRequest}
            hasErrorRequestBookingInfo={props.hasErrorRequestBookingInfo}
            history={props.history}
        />
    } else {
        // This component displays the loader logo and the details of the booking. If there is an error
        // it displays the search component above
        if (props.isRequestingStoresList || props.isRequestingBookingInfo) {
            mainComponent = <LogoLoader />;
        } else if (props.bookingInfo !== null) {
            mainComponent = <EditBookingFound
                visitDate={props.bookingInfo.VisitDate}
                visitTime={props.bookingInfo.VisitTime}
                partySize={props.bookingInfo.PartySize}
                canCancel={props.bookingInfo.CanCancel}
                storeName={props.bookingInfo.RestaurantName}
                canEdit={props.bookingInfo.CanEdit}
                editClicked={() => props.editBookingClicked(props.history)}
                translations={props.translations}
                bookingCode={props.bookingCode}
                deleteClicked={() => {
                    props.history.replace('/cancella-prenotazione');
                    props.deleteBookingClicked({ bookingCode: props.bookingCode, storeId: props.storeId })
                }}
            />
        }
    }
    return (
        <React.Fragment>
            {mainComponent}
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/containers/EditBooking/EditBookingComponent.js